import { useRoute } from '@core/navigation';
import { RoutePath } from '@common/constants';
import { SuccessScreen } from '@common/features';
import { useBootstrapData } from '@bootstrap/hooks';

export const UploadSuccess = () => {
  const [
    {
      search: { payor, email },
    },
    { push },
  ] = useRoute<object, { payor: string; email: string }>();
  const { uploads } = useBootstrapData();

  const successEntity = uploads.find(({ type }) => type === 'dme');

  const handleCTAClick = () => {
    push({ path: RoutePath.ROOT_BENEFITS });
  };

  return (
    <SuccessScreen
      title={successEntity.title}
      body={successEntity.message}
      image={{ url: successEntity.image }}
      bodyTemplateVariables={{ payor, email }}
      defaultHref={RoutePath.ROOT_BENEFITS}
      onCtaClick={handleCTAClick}
    />
  );
};
